export const SERVICE_CODE = 'DASHBOARD_CONSULTANT_SALES' + '_SERVICE';
